// TODO: Needs to be moved to Utils
window.Helpers = Object.assign(window.Helpers || {}, {
  // NOTE: don't delete until Safari updates the smooth behavior
  scrollToElement: function(elementSelector, offset) {
    var elementTop = $(elementSelector).offset().top + (offset || 0);
    $('html, body').stop().animate({scrollTop:elementTop}, 500, 'swing');
  },
});



